export const validatePatientSupplement = (field, value) => {
  let errMsg = '';
  switch (field) {
    case 'name':
      if (!value) {
        errMsg = 'Name should not be empty';
      }
      break;
    default:
      errMsg = '';
  }

  return { [field]: errMsg };
};
